module.exports = __webpack_public_path__ + "img/tit-en.46b219d2.jpg";